export const createAccordion = (element) => {
  if (!element || element.length === 0) {
    return null;
  }

  const instance = {
    $element: null,
    $items: null,

    init: function (element) {
      this.$element = jQuery(element);
      if (this.$element.data("initialized")) return;
      this.$element.data("initialized", true);

      this.$items = this.$element.find(".js-accordion-item");
      this.setupEventListeners();
    },

    setupEventListeners: function () {
      this.$items.each((_, item) => {
        const $item = jQuery(item);
        const $trigger = $item.find(".js-accordion-trigger");

        if ($trigger.length) {
          $trigger.on("click", (e) => {
            e.preventDefault();
            this.toggleAccordion($item);
          });
        }
      });
    },

    toggleAccordion: function ($item) {
      const $content = $item.find(".js-accordion-content");
      const $icon = $item.find(".js-accordion-icon");

      if (!$content.length || !$icon.length) return;

      // Close other accordions
      this.$items.not($item).each((_, otherItem) => {
        const $otherItem = jQuery(otherItem);
        const $otherContent = $otherItem.find(".js-accordion-content");
        const $otherIcon = $otherItem.find(".js-accordion-icon");

        $otherContent.addClass("hidden");
        $otherIcon.removeClass("rotate-180");
      });

      // Toggle current accordion
      $content.toggleClass("hidden");
      $icon.toggleClass("rotate-180");
    },
  };

  instance.init(element);
  return instance;
};
